module.exports = __webpack_public_path__ + "media/images/public-mobile-bg-87821c0fe4f2c544aaec360d7bdb2dae.png";